@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;

.fallback {
  @include typography-v2-title-sm;
  @include border-radius-full;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;

  &.small {
    @include typography-v2-title-xs;

    width: 16px;
    height: 16px;
  }
}
